// WallColorSchemaData.js — "Wall Color Schema / Curtain Colors" reference table
// shown right after the Coloured Zone report (edit view + PDF). Every label
// and colour name carries all 8 languages so both follow the language dropdown.

import { pickLang } from './i18n/languageOptions';

const tr = (en, hi, gu, mr, bn, kn, ta, te) => ({ en, hi, gu, mr, bn, kn, ta, te });

export const WALL_COLOR_LABELS = {
  title: tr('Wall Color Schema/Curtain Colors', 'दीवार रंग योजना/पर्दे के रंग', 'દીવાલ રંગ યોજના/પડદાના રંગો', 'भिंतीचे रंग योजना/पडद्यांचे रंग', 'দেয়ালের রঙের পরিকল্পনা/পর্দার রঙ', 'ಗೋಡೆ ಬಣ್ಣ ಯೋಜನೆ/ಪರದೆ ಬಣ್ಣಗಳು', 'சுவர் வண்ணத் திட்டம்/திரைச்சீலை வண்ணங்கள்', 'గోడ రంగుల పథకం/కర్టెన్ రంగులు'),
  colorZone: tr('Color Zone', 'रंग ज़ोन', 'રંગ ઝોન', 'रंग झोन', 'রঙের জোন', 'ಬಣ್ಣ ವಲಯ', 'வண்ண மண்டலம்', 'రంగు జోన్'),
  favorable: tr('Favorable Color', 'अनुकूल रंग', 'અનુકૂળ રંગ', 'अनुकूल रंग', 'অনুকূল রঙ', 'ಅನುಕೂಲಕರ ಬಣ್ಣ', 'சாதகமான நிறம்', 'అనుకూల రంగు'),
  anti: tr('Anti-Color', 'प्रतिकूल रंग', 'પ્રતિકૂળ રંગ', 'प्रतिकूल रंग', 'প্রতিকূল রঙ', 'ಪ್ರತಿಕೂಲ ಬಣ್ಣ', 'எதிர்மறை நிறம்', 'ప్రతికూల రంగు'),
  possible: tr('Possible Colors', 'संभावित रंग', 'શક્ય રંગો', 'शक्य रंग', 'সম্ভাব্য রঙ', 'ಸಾಧ್ಯ ಬಣ್ಣಗಳು', 'சாத்தியமான நிறங்கள்', 'సాధ్యమైన రంగులు'),
  note1: tr(
    'All pastel colors like cream and off-white are neutral colors and can be used without any worry. Try to use light color shades.',
    'क्रीम और ऑफ-व्हाइट जैसे सभी पेस्टल रंग तटस्थ रंग हैं और बिना किसी चिंता के उपयोग किए जा सकते हैं। हल्के रंगों के शेड्स का उपयोग करने का प्रयास करें।',
    'ક્રીમ અને ઓફ-વ્હાઇટ જેવા બધા પેસ્ટલ રંગો તટસ્થ રંગો છે અને કોઈપણ ચિંતા વગર વાપરી શકાય છે. હળવા રંગના શેડ્સ વાપરવાનો પ્રયાસ કરો.',
    'क्रीम आणि ऑफ-व्हाइट सारखे सर्व पेस्टल रंग तटस्थ रंग आहेत आणि कोणतीही चिंता न करता वापरता येतात. फिकट रंगछटा वापरण्याचा प्रयत्न करा.',
    'ক্রিম ও অফ-হোয়াইটের মতো সব প্যাস্টেল রঙ নিরপেক্ষ রঙ এবং নির্দ্বিধায় ব্যবহার করা যায়। হালকা রঙের শেড ব্যবহার করার চেষ্টা করুন।',
    'ಕ್ರೀಮ್ ಮತ್ತು ಆಫ್-ವೈಟ್‌ನಂತಹ ಎಲ್ಲಾ ಪ್ಯಾಸ್ಟೆಲ್ ಬಣ್ಣಗಳು ತಟಸ್ಥ ಬಣ್ಣಗಳಾಗಿದ್ದು ಯಾವುದೇ ಚಿಂತೆಯಿಲ್ಲದೆ ಬಳಸಬಹುದು. ತಿಳಿ ಬಣ್ಣದ ಛಾಯೆಗಳನ್ನು ಬಳಸಲು ಪ್ರಯತ್ನಿಸಿ.',
    'கிரீம் மற்றும் ஆஃப்-வைட் போன்ற அனைத்து பேஸ்டல் நிறங்களும் நடுநிலை நிறங்கள்; எந்தக் கவலையும் இன்றிப் பயன்படுத்தலாம். வெளிர் நிற சாயல்களைப் பயன்படுத்த முயற்சிக்கவும்.',
    'క్రీమ్ మరియు ఆఫ్-వైట్ వంటి అన్ని పాస్టెల్ రంగులు తటస్థ రంగులు మరియు ఎలాంటి చింత లేకుండా ఉపయోగించవచ్చు. లేత రంగు ఛాయలను ఉపయోగించడానికి ప్రయత్నించండి.'),
  note2: tr(
    'Zones not marked with any color fall under the Grey zone.',
    'जिन ज़ोन पर कोई रंग अंकित नहीं है, वे ग्रे ज़ोन के अंतर्गत आते हैं।',
    'જે ઝોન પર કોઈ રંગ દર્શાવ્યો નથી તે ગ્રે ઝોન હેઠળ આવે છે.',
    'ज्या झोनवर कोणताही रंग दर्शवलेला नाही ते ग्रे झोनमध्ये येतात.',
    'যে জোনে কোনো রঙ চিহ্নিত নেই সেগুলি গ্রে জোনের অন্তর্গত।',
    'ಯಾವುದೇ ಬಣ್ಣ ಗುರುತಿಸದ ವಲಯಗಳು ಬೂದು ವಲಯದ ಅಡಿಯಲ್ಲಿ ಬರುತ್ತವೆ.',
    'எந்த நிறமும் குறிக்கப்படாத மண்டலங்கள் சாம்பல் மண்டலத்தின் கீழ் வரும்.',
    'ఏ రంగూ గుర్తించని జోన్‌లు గ్రే జోన్ కిందకు వస్తాయి.'),
};

// name (all 8 languages) + display colour (kept readable on white — "White"
// is drawn dark grey, exactly as in the reference table).
export const WALL_COLORS = {
  blue:     { hex: '#1f3fff', name: tr('Blue', 'नीला', 'વાદળી', 'निळा', 'নীল', 'ನೀಲಿ', 'நீலம்', 'నీలం') },
  black:    { hex: '#000000', name: tr('Black', 'काला', 'કાળો', 'काळा', 'কালো', 'ಕಪ್ಪು', 'கருப்பு', 'నలుపు') },
  red:      { hex: '#e11d1d', name: tr('Red', 'लाल', 'લાલ', 'लाल', 'লাল', 'ಕೆಂಪು', 'சிவப்பு', 'ఎరుపు') },
  pink:     { hex: '#f08cb5', name: tr('Pink', 'गुलाबी', 'ગુલાબી', 'गुलाबी', 'গোলাপি', 'ಗುಲಾಬಿ', 'இளஞ்சிவப்பு', 'గులాబీ') },
  orange:   { hex: '#f59e0b', name: tr('Orange', 'नारंगी', 'નારંગી', 'नारिंगी', 'কমলা', 'ಕಿತ್ತಳೆ', 'ஆரஞ்சு', 'నారింజ') },
  violet:   { hex: '#8b5cf6', name: tr('Violet', 'बैंगनी', 'જાંબલી', 'जांभळा', 'বেগুনি', 'ನೇರಳೆ', 'ஊதா', 'వైలెట్') },
  purple:   { hex: '#7e22ce', name: tr('Purple', 'जामुनी', 'જાંબુડી', 'गडद जांभळा', 'গাঢ় বেগুনি', 'ಕೆನ್ನೇರಳೆ', 'அடர் ஊதா', 'ఊదా') },
  lilac:    { hex: '#b79ce0', name: tr('Lilac', 'लाइलैक', 'લાયલેક', 'लायलॅक', 'লিলাক', 'ಲೈಲಾಕ್', 'லைலாக்', 'లైలాక్') },
  green:    { hex: '#16a34a', name: tr('Green', 'हरा', 'લીલો', 'हिरवा', 'সবুজ', 'ಹಸಿರು', 'பச்சை', 'ఆకుపచ్చ') },
  brown:    { hex: '#8b5a2b', name: tr('Brown', 'भूरा', 'ભૂરો', 'तपकिरी', 'বাদামি', 'ಕಂದು', 'பழுப்பு', 'గోధుమ') },
  wood:     { hex: '#c9a06a', name: tr('Wood', 'लकड़ी', 'લાકડું', 'लाकूड', 'কাঠ', 'ಮರ', 'மரம்', 'కలప') },
  white:    { hex: '#374151', name: tr('White', 'सफ़ेद', 'સફેદ', 'पांढरा', 'সাদা', 'ಬಿಳಿ', 'வெள்ளை', 'తెలుపు') },
  metallic: { hex: '#9ca3af', name: tr('Metallic', 'धात्विक', 'ધાતુ', 'धातू', 'ধাতব', 'ಲೋಹೀಯ', 'உலோக', 'లోహ') },
  silver:   { hex: '#b0b7c3', name: tr('Silver', 'चांदी', 'ચાંદી', 'चांदी', 'রুপালি', 'ಬೆಳ್ಳಿ', 'வெள்ளி', 'వెండి') },
  yellow:   { hex: '#f2c200', name: tr('Yellow', 'पीला', 'પીળો', 'पिवळा', 'হলুদ', 'ಹಳದಿ', 'மஞ்சள்', 'పసుపు') },
  beige:    { hex: '#dcc59a', name: tr('Beige', 'बेज', 'બેજ', 'बेज', 'বেইজ', 'ಬೀಜ್', 'பெய்ஜ்', 'బీజ్') },
  grey:     { hex: '#6b7280', name: tr('Grey', 'ग्रे', 'ગ્રે', 'राखाडी', 'ধূসর', 'ಬೂದು', 'சாம்பல்', 'బూడిద') },
};

// Each cell is a list of groups; a group is "A / B / C" and groups sit next to
// each other (wrapping), matching the reference table.
export const WALL_COLOR_ROWS = [
  { zone: 'blue',
    favorable: [['blue', 'black']],
    anti: [['red', 'pink', 'orange', 'violet', 'purple', 'lilac']],
    possible: [['green', 'brown', 'wood'], ['white', 'metallic', 'silver']] },
  { zone: 'green',
    favorable: [['green', 'brown', 'wood']],
    anti: [['yellow', 'beige']],
    possible: [['blue', 'black'], ['red', 'pink', 'orange'], ['white', 'metallic', 'silver']] },
  { zone: 'red',
    favorable: [['red', 'pink', 'orange', 'violet', 'purple', 'lilac']],
    anti: [['white', 'metallic', 'silver'], ['blue', 'black']],
    possible: [['green', 'brown', 'wood'], ['yellow', 'beige']] },
  { zone: 'yellow',
    favorable: [['yellow', 'beige']],
    anti: [['blue', 'black'], ['green', 'brown', 'wood']],
    possible: [['red', 'pink', 'orange'], ['white', 'silver']] },
  { zone: 'grey',
    favorable: [['white', 'metallic', 'silver']],
    anti: [['green', 'brown', 'wood'], ['red', 'pink', 'orange', 'violet', 'purple', 'lilac']],
    possible: [['yellow', 'beige'], ['blue', 'black']] },
];

export const wallColorLabel = (key, lang = 'en') => pickLang(WALL_COLORS[key].name, lang);
export const wallLabel = (key, lang = 'en') => pickLang(WALL_COLOR_LABELS[key], lang);

// Flattens a cell into coloured tokens: [{ text, hex }] with " / " separators
// inside a group and a plain space between groups. Used by the PDF layout so
// it can wrap word-by-word while keeping each colour name in its own colour.
export const wallCellTokens = (cell, lang = 'en') => {
  const tokens = [];
  cell.forEach((group, gi) => {
    if (gi > 0) tokens.push({ text: ' ', hex: null });
    group.forEach((key, ki) => {
      if (ki > 0) tokens.push({ text: ' / ', hex: null });
      tokens.push({ text: wallColorLabel(key, lang), hex: WALL_COLORS[key].hex });
    });
  });
  return tokens;
};
